import React from "react";

const LoadingOverlay = ({
  text = "載入中...",
  zIndex = 2000,
  showCancel,
  onCancel,
  showRetry,
  onRetry,
  errorText,
}) => (
  <div
    className="fixed inset-0 flex flex-col items-center justify-center bg-black/70 backdrop-blur-sm z-[2000]"
    style={{ zIndex }}
  >
    <div className="w-14 h-14 border-4 border-amber-300 border-t-amber-700 rounded-full animate-spin mb-4" />
    <div className="text-lg font-bold text-amber-200 mb-2 drop-shadow">
      {text}
    </div>
    {errorText && (
      <div className="text-red-200 bg-red-900/80 rounded px-4 py-2 mb-2 text-sm text-center border border-red-700 animate-pulse">
        {errorText}
      </div>
    )}
    {showRetry && (
      <button
        onClick={onRetry}
        className="mt-2 px-5 py-2 rounded-full bg-[#181c23] text-amber-200 font-bold shadow hover:bg-amber-700/80 hover:text-white transition-colors border border-amber-700"
      >
        重新嘗試
      </button>
    )}
    {showCancel && (
      <button
        onClick={onCancel}
        className="mt-2 px-5 py-2 rounded-full bg-[#181c23] text-amber-200 font-bold shadow hover:bg-amber-700/80 hover:text-white transition-colors border border-amber-700"
      >
        取消
      </button>
    )}
  </div>
);

export default LoadingOverlay;
